module.exports = "<footer class=\"footer w3-dark-grey\">\n  <div *ngIf=\"isLoggedIn\" class=\"container has-text-centered\">\n    <p>You are logged in as <b>{{user?.email}}</b></p>\n    <a (click)=\"signOut()\" class=\"button is-primary is-inverted\">Log Out</a>\n  </div>\n  <div class=\"has-text-centered\">\n    <a *ngIf=\"!isLoggedIn\" routerLink=\"admin\">\n      ADMIN\n    </a>\n  </div>\n\n</footer>\n"


//////////////////
// WEBPACK FOOTER
// /Users/trevor/src/src-westoaks3/west-oaks/src/app/footer/footer.component.html
// module id = ../../../../../src/app/footer/footer.component.html
// module chunks = main